enum AccountDetailsConfigKeys {
  ActiveTab = 'activeTab',
}

interface AccountDetailsConfig {
  [AccountDetailsConfigKeys.ActiveTab]: AccountDetailsTabs
}

enum AccountDetailsTabs {
  Summary = 'Summary',
  Holdings = 'Holdings',
}

export const defaultAccountDetailsConfig: AccountDetailsConfig = {
  [AccountDetailsConfigKeys.ActiveTab]: AccountDetailsTabs.Summary,
}
